export class ScopeRentalModel {
  [key : string] : number;

  public lightFleetRental: number = 0;
  public collectiveTransportRental: number = 0;
  public workshopTruckRental: number = 0;
  public tractorRental: number = 0;
  public trailerRental: number = 0;
}
